<template>
  <div class="item-box">
    <router-link :to="getDetailUrl(product.ProType,product.ProId)" class="item">
      <img :src="product.ProImage" v-lazy="product.ProImage" alt class="item-img" />
      <div class="item-con">
        <div class="tit">{{product.ProName}}</div>
        <div class="item-price">
          <sub>&yen;</sub>
          <span class="price">{{product.ProPrice}}</span>
          <span class="unprice" v-if="product.OriginalPrice > 0 && product.OriginalPrice !==product.ProPrice">&yen;{{product.OriginalPrice}}</span>
          <span class="price-suffix"></span>
          <span class="icon-box">
          </span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import pm from '../common/product-mixin.js'
export default {
  name: "SubjectItemProduct",
  props: {
    product: {}
  },
  mixins:[pm],
  data() {
    return {
      imgs: ""
    };
  }
};
</script>

<style lang="less" scoped>
.item-box {
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #fff;
}
.item-box .item {
  position: relative;
}
.item .item-img {
  max-width: 100%;
  width: 100%;
  border-radius:8px;
}
.item .item-con {
  text-align: left;
  display: block;
  padding: 0 10px 10px 10px;
}
.item-con .tit {
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-con .item-price {
  color: #ff6700;
  display: flex;
  //   align-items: flex-end;
  margin-top: 5px;
  line-height: 1;
  align-items: flex-end;
}
.item-price sub {
  //top: 2px;
  font-size: 12px;
  margin-right: 2px;
  padding-bottom: 2px;
}
.item-price .price {
  font-size: 18px;
  display: inline-flex;
  align-items: flex-end;
}

.item-price .unprice {
  font-size: 14px;
  display: inline-flex;
  align-items: flex-end;
  text-decoration: line-through;
  color: #969799;
  margin-left: 5px;
}
.item-price .price-suffix {
  display:inline-flex;
  align-items: flex-end;
  font-size: 12px;
  margin: 0px;
  padding-bottom: 3px;
}
.item-price .icon-box {
  display: inline-block;
  flex: 1;
  padding-left: 5px;
  vertical-align: bottom;
}
</style>